import React from "react";
import "../pages/css/add-property.css";
import cloud from "../assets/cloud.png";

const DocUpload = ({ docs, setDocs, setData, data, dataErr }) => {
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    if (files.length + docs.length > 5) {
      alert("You can only upload up to 5 documents.");
      return;
    }
    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    const processFiles = async () => {
      const newDocs = await Promise.all(
      files.map(async (file) => ({
        documentName: file.name,
        document: await convertToBase64(file),
      }))
    );
      setDocs((prevDocs) => [...prevDocs, ...newDocs]);
      setData({ ...data, document: newDocs.map((doc) => doc.base64) });
    };

    processFiles();
  };

  return (
    <div className="images prop-form_cont">
      <label
        htmlFor="doc"
        className="prop-form img-upload"
        style={{ width: "100%" }}
      >
        <input
          type="file"
          name="doc"
          id="doc"
          style={{ display: "none" }}
          multiple
          accept=".pdf"
          onChange={handleFileChange}
        />
        <img src={cloud} alt="upload" />
        <p>
          <span>Click to upload</span> <br />
          pdf <br />
          Upload max. 5 in total
        </p>
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <div className="file_cont">
            {docs?.map((item, idx) => (
              <p key={idx}>{item?.documentName}</p>
            ))}
          </div>
        </div>
      </label>
      {dataErr?.document && <p>{dataErr?.document}</p>}
    </div>
  );
};

export default DocUpload;
